/**
 * Facebook Loader
 *
 * @author Space-Time Inc.
 * @version 2022-08-29
 */

const wrap = document.querySelector('.loading-wrap');
const loaderDisplay = function () {
	wrap.classList.remove('active');
	wrap.classList.add('hide');
}
window.addEventListener('DOMContentLoaded', function () {
	if (!sessionStorage.getItem('disp')) {
		wrap.classList.add('active');
		window.addEventListener('load', function () {
			setTimeout(loaderDisplay, 1000);
		}, false);
		sessionStorage.setItem('disp', 'on');
	} else {
		wrap.classList.add('hide');
	}
});
